<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <div class="user-panel-default">
          <div class="row my-4 pb-1 ">
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="title"
                                  [required]="true"
                                  [title]="'Title'"
                                  [type]="'text'"></app-frontend-input>
            </div>
            <div class="col-md-6 col-12">
              <app-frontend-input [(value)]="domainName"
                                  [required]="true"
                                  [title]="'DomainName'"
                                  [type]="'text'"></app-frontend-input>
            </div>
            @if (!domain) {
              <div class="col-md-6 col-12">
                <app-frontend-select [(value)]="businessId"
                                     [controller]="'businesses'"
                                     [displayKey]="'Title'"
                                     [fieldName]="'BusinessId'"
                                     [method]="'getBranches'"
                                     [microservice]="Constant.FOOD_SHOP"
                                     [protocolMethod]="'POST'"
                                     [required]="true"
                                     [searchOnKey]="'Title'"
                                     [selectedOptions]="[this.domain?.Business]"
                                     [title]="'Branch'"
                                     [version]="'v1'"></app-frontend-select>
              </div>
            }
            <div class="col-md-6 col-12">
              <app-frontend-button (click)="onDetailClicked()"
                                   [Image]="true"
                                   [class]="'card-green-light'"
                                   [endpoint]=""
                                   [src]="'icons/tick-square.svg'"
                                   [title]="'Details'"
                                   [validationRequired]="true"
                                   class="mt-2"></app-frontend-button>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex align-items-center justify-content-end footer"
             style="gap: 16px">
          <app-frontend-button (onSubmit)="onSubmitClicked()"
                               [Image]="true"
                               [class]="'card-green'"
                               [disabled]="false"
                               [src]="'icons/tick-square.svg'"
                               [title]="'Submit'"
                               [validationRequired]="true">
          </app-frontend-button>
          <app-frontend-button (click)="onCancelClicked()"
                               [Image]="true"
                               [class]="'card-yellow'"
                               [disabled]="false"
                               [src]="'icons/close-square.svg'"
                               [title]="'Cancel'">
          </app-frontend-button>
        </div>
      </div>
    </div>
  </div>
</div>
